export interface ISurcharge {
  surchargeName?: string;
  currency?: string;
  defaultPercentSurcharge?: number;
  amountCriteria?: {
    minSurchargeableAmount?: string;
    maxSurchargeableAmount?: string;
  };
  paymentTypeSurcharge?: {
    paymentType?: string;
    cardProductId?: string;
    percentSurcharge?: number;
  }[];
}
